import { render, staticRenderFns } from "./bwsubscribers.vue?vue&type=template&id=fdc098bc&"
import script from "./bwsubscribers.vue?vue&type=script&lang=js&"
export * from "./bwsubscribers.vue?vue&type=script&lang=js&"
import style0 from "./bwsubscribers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports